import { render, staticRenderFns } from "./AdminView.vue?vue&type=template&id=2c81d2a4&scoped=true&"
import script from "./AdminView.vue?vue&type=script&lang=ts&"
export * from "./AdminView.vue?vue&type=script&lang=ts&"
import style0 from "./AdminView.vue?vue&type=style&index=0&id=2c81d2a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c81d2a4",
  null
  
)

export default component.exports